






















































import { Component, Vue } from 'vue-property-decorator';
import Employee from '@/models/Employee';
import StarRating from 'vue-star-rating';
import { Getter } from 'vuex-class';

@Component({
  components: {
    StarRating
  }
})
export default class EmployeeList extends Vue {
  isOpened = false;
  selectedEmployee = {};

  get employees(): any {
    return this.$store.state.employees;
  }

  viewEmployee(employee: Employee) {
    this.selectedEmployee = employee;
    this.isOpened = true;
  }

  selectEmployee() {
    this.isOpened = false;
  }
}
